/**
 * WMC Medication Travel — controlled-substance ATC lookup (Phase 1).
 *
 * Source: INCB Yellow List (narcotic drugs, 1961 Single Convention, 64th ed. 2025)
 * and INCB Green List (psychotropic substances, 1971 Convention, 2025, V.24-12193).
 *
 * DRAFT DATA — requires clinical sign-off before the feature is
 * enabled. A match means the medicine is INTERNATIONALLY CONTROLLED; it is NOT a
 * ruling on whether the medicine is legal at any destination. Destination rules
 * are national and vary — the UI must never present a verdict.
 */

// ATC code -> { inns:[], list:['narcotic'|'psychotropic'], schedule:[] }
export const CONTROLLED_ATC = {
  "A04AD10": {
    "inns": [
      "dronabinol"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dronabinol"
  },
  "A07DA01": {
    "inns": [
      "diphenoxylate"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Diphenoxylate"
  },
  "A07DA02": {
    "inns": [
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Opium"
  },
  "A07DA04": {
    "inns": [
      "difenoxine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Difenoxin"
  },
  "A07DA52": {
    "inns": [
      "morphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Morphine, combinations"
  },
  "A08AA01": {
    "inns": [
      "phentermine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Phentermine"
  },
  "A08AA03": {
    "inns": [
      "amfepramone"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Amfepramone"
  },
  "A08AA05": {
    "inns": [
      "mazindol"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Mazindol"
  },
  "A08AA06": {
    "inns": [
      "etilamfetamine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Etilamfetamine"
  },
  "A08AA07": {
    "inns": [
      "cathine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Cathine"
  },
  "A08AA09": {
    "inns": [
      "mefenorex"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Mefenorex"
  },
  "A08AA51": {
    "inns": [
      "phentermine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Phentermine and topiramate"
  },
  "M03BX07": {
    "inns": [
      "tetrazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Tetrazepam"
  },
  "N01AH01": {
    "inns": [
      "fentanyl"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Fentanyl"
  },
  "N01AH02": {
    "inns": [
      "alfentanil"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Alfentanil"
  },
  "N01AH03": {
    "inns": [
      "sufentanil"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Sufentanil"
  },
  "N01AH04": {
    "inns": [
      "phenoperidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Phenoperidine"
  },
  "N01AH05": {
    "inns": [
      "anileridine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Anileridine"
  },
  "N01AH06": {
    "inns": [
      "remifentanil"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Remifentanil"
  },
  "N01AH51": {
    "inns": [
      "fentanyl"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Fentanyl, combinations"
  },
  "N01AX11": {
    "inns": [
      "gamma-hydroxybutyric acid"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Sodium oxybate"
  },
  "N01BC01": {
    "inns": [
      "cocaine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Cocaine"
  },
  "N02AA01": {
    "inns": [
      "morphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Morphine"
  },
  "N02AA02": {
    "inns": [
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "opium"
  },
  "N02AA03": {
    "inns": [
      "hydromorphone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Hydromorphone"
  },
  "N02AA04": {
    "inns": [
      "nicomorphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Nicomorphine"
  },
  "N02AA05": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone"
  },
  "N02AA08": {
    "inns": [
      "dihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dihydrocodeine"
  },
  "N02AA11": {
    "inns": [
      "oxymorphone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxymorphone"
  },
  "N02AA51": {
    "inns": [
      "morphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "morphine, combinations"
  },
  "N02AA53": {
    "inns": [
      "hydromorphone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Hydromorphone and naloxone"
  },
  "N02AA55": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone and naloxone"
  },
  "N02AA56": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone and naltrexone"
  },
  "N02AA58": {
    "inns": [
      "dihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dihydrocodeine, combinations"
  },
  "N02AA59": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine, combinations excl. psycholeptics"
  },
  "N02AA79": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine, combinations with psycholeptics"
  },
  "N02AB01": {
    "inns": [
      "ketobemidone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Ketobemidone"
  },
  "N02AB02": {
    "inns": [
      "pethidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Pethidine"
  },
  "N02AB03": {
    "inns": [
      "fentanyl"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "fentanyl"
  },
  "N02AB52": {
    "inns": [
      "pethidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Pethidine, combinations excl. psycholeptics"
  },
  "N02AB72": {
    "inns": [
      "pethidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Pethidine, combinations with psycholeptics"
  },
  "N02AC01": {
    "inns": [
      "dextromoramide"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Dextromoramide"
  },
  "N02AC03": {
    "inns": [
      "piritramide"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Piritramide"
  },
  "N02AC04": {
    "inns": [
      "dextropropoxyphene"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dextropropoxyphene"
  },
  "N02AC05": {
    "inns": [
      "bezitramide"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Bezitramide"
  },
  "N02AC52": {
    "inns": [
      "methadone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Methadone, combinations excl. psycholeptics"
  },
  "N02AC54": {
    "inns": [
      "dextropropoxyphene"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dextropropoxyphene, combinations excl. psycholeptics"
  },
  "N02AC74": {
    "inns": [
      "dextropropoxyphene"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dextropropoxyphene, combinations with psycholeptics"
  },
  "N02AD01": {
    "inns": [
      "pentazocine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Pentazocine"
  },
  "N02AD02": {
    "inns": [
      "phenazocine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Phenazocine"
  },
  "N02AE01": {
    "inns": [
      "buprenorphine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Buprenorphine"
  },
  "N02AG01": {
    "inns": [
      "morphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Morphine and antispasmodics"
  },
  "N02AG02": {
    "inns": [
      "ketobemidone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Ketobemidone and antispasmodics"
  },
  "N02AG03": {
    "inns": [
      "pethidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Pethidine and antispasmodics"
  },
  "N02AG04": {
    "inns": [
      "hydromorphone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Hydromorphone and antispasmodics"
  },
  "N02AJ01": {
    "inns": [
      "dihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dihydrocodeine and paracetamol"
  },
  "N02AJ02": {
    "inns": [
      "dihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dihydrocodeine and acetylsalicylic acid"
  },
  "N02AJ03": {
    "inns": [
      "dihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dihydrocodeine and other non-opioid analgesics"
  },
  "N02AJ06": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine and paracetamol"
  },
  "N02AJ07": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine and acetylsalicylic acid"
  },
  "N02AJ08": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine and ibuprofen"
  },
  "N02AJ09": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine and other non-opioid analgesics"
  },
  "N02AJ17": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone and paracetamol"
  },
  "N02AJ18": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone and acetylsalicylic acid"
  },
  "N02AJ19": {
    "inns": [
      "oxycodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Oxycodone and ibuprofen"
  },
  "N02AX01": {
    "inns": [
      "tilidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Tilidine"
  },
  "N02AX06": {
    "inns": [
      "tapentadol"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Tapentadol"
  },
  "N02AX51": {
    "inns": [
      "tilidine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Tilidine and naloxone"
  },
  "N03AA01": {
    "inns": [
      "methylphenobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Methylphenobarbital"
  },
  "N03AA02": {
    "inns": [
      "phenobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Phenobarbital"
  },
  "N03AE01": {
    "inns": [
      "clonazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Clonazepam"
  },
  "N05BA01": {
    "inns": [
      "diazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Diazepam"
  },
  "N05BA02": {
    "inns": [
      "chlordiazepoxide"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Chlordiazepoxide"
  },
  "N05BA03": {
    "inns": [
      "medazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Medazepam"
  },
  "N05BA04": {
    "inns": [
      "oxazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Oxazepam"
  },
  "N05BA05": {
    "inns": [
      "clorazepate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Potassium clorazepate"
  },
  "N05BA06": {
    "inns": [
      "lorazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Lorazepam"
  },
  "N05BA08": {
    "inns": [
      "bromazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Bromazepam"
  },
  "N05BA09": {
    "inns": [
      "clobazam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Clobazam"
  },
  "N05BA10": {
    "inns": [
      "ketazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Ketazolam"
  },
  "N05BA11": {
    "inns": [
      "prazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Prazepam"
  },
  "N05BA12": {
    "inns": [
      "alprazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Alprazolam"
  },
  "N05BA13": {
    "inns": [
      "halazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Halazepam"
  },
  "N05BA14": {
    "inns": [
      "pinazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Pinazepam"
  },
  "N05BA15": {
    "inns": [
      "camazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Camazepam"
  },
  "N05BA16": {
    "inns": [
      "nordazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Nordazepam"
  },
  "N05BA17": {
    "inns": [
      "fludiazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Fludiazepam"
  },
  "N05BA18": {
    "inns": [
      "ethyl loflazepate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Ethyl loflazepate"
  },
  "N05BA19": {
    "inns": [
      "etizolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Etizolam"
  },
  "N05BA21": {
    "inns": [
      "clotiazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Clotiazepam"
  },
  "N05BA22": {
    "inns": [
      "cloxazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Cloxazolam"
  },
  "N05BA56": {
    "inns": [
      "lorazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Lorazepam, combinations"
  },
  "N05BC01": {
    "inns": [
      "meprobamate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Meprobamate"
  },
  "N05BC51": {
    "inns": [
      "meprobamate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Meprobamate, combinations"
  },
  "N05CA01": {
    "inns": [
      "pentobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Pentobarbital"
  },
  "N05CA02": {
    "inns": [
      "amobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Amobarbital"
  },
  "N05CA03": {
    "inns": [
      "butobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Butobarbital"
  },
  "N05CA04": {
    "inns": [
      "barbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Barbital"
  },
  "N05CA06": {
    "inns": [
      "secobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Secobarbital"
  },
  "N05CA08": {
    "inns": [
      "vinylbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Vinylbital"
  },
  "N05CA09": {
    "inns": [
      "vinylbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Vinbarbital"
  },
  "N05CA10": {
    "inns": [
      "cyclobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Cyclobarbital"
  },
  "N05CA21": {
    "inns": [
      "allobarbital"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Allobarbital"
  },
  "N05CD01": {
    "inns": [
      "flurazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Flurazepam"
  },
  "N05CD02": {
    "inns": [
      "nitrazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Nitrazepam"
  },
  "N05CD03": {
    "inns": [
      "flunitrazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Flunitrazepam"
  },
  "N05CD04": {
    "inns": [
      "estazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Estazolam"
  },
  "N05CD05": {
    "inns": [
      "triazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Triazolam"
  },
  "N05CD06": {
    "inns": [
      "lormetazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Lormetazepam"
  },
  "N05CD07": {
    "inns": [
      "temazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Temazepam"
  },
  "N05CD08": {
    "inns": [
      "midazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Midazolam"
  },
  "N05CD09": {
    "inns": [
      "brotizolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Brotizolam"
  },
  "N05CD11": {
    "inns": [
      "loprazolam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Loprazolam"
  },
  "N05CD15": {
    "inns": [
      "nimetazepam"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Nimetazepam"
  },
  "N05CE01": {
    "inns": [
      "glutethimide"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Glutethimide"
  },
  "N05CE02": {
    "inns": [
      "methyprylon"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Methyprylon"
  },
  "N05CF02": {
    "inns": [
      "zolpidem"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Zolpidem"
  },
  "N05CM01": {
    "inns": [
      "methaqualone"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Methaqualone"
  },
  "N05CM08": {
    "inns": [
      "ethchlorvynol"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Ethchlorvynol"
  },
  "N05CX01": {
    "inns": [
      "meprobamate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "meprobamate, combinations"
  },
  "N05CX02": {
    "inns": [
      "methaqualone"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Methaqualone, combinations"
  },
  "N06AA19": {
    "inns": [
      "amineptine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Amineptine"
  },
  "N06BA01": {
    "inns": [
      "amfetamine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Amfetamine"
  },
  "N06BA02": {
    "inns": [
      "dexamfetamine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Dexamfetamine"
  },
  "N06BA03": {
    "inns": [
      "metamfetamine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Metamfetamine"
  },
  "N06BA04": {
    "inns": [
      "methylphenidate"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Methylphenidate"
  },
  "N06BA05": {
    "inns": [
      "pemoline"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Pemoline"
  },
  "N06BA06": {
    "inns": [
      "fencamfamin"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Fencamfamin"
  },
  "N06BA10": {
    "inns": [
      "fenetylline"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Fenetylline"
  },
  "N06BX15": {
    "inns": [
      "pipradrol"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "IV"
    ],
    "name": "Pipradrol"
  },
  "N07BC01": {
    "inns": [
      "buprenorphine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "buprenorphine"
  },
  "N07BC02": {
    "inns": [
      "methadone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Methadone"
  },
  "N07BC03": {
    "inns": [
      "methadone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Levacetylmethadol"
  },
  "N07BC05": {
    "inns": [
      "methadone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Levomethadone"
  },
  "N07BC06": {
    "inns": [
      "heroin"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Diamorphine"
  },
  "N07BC51": {
    "inns": [
      "buprenorphine"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "III"
    ],
    "name": "Buprenorphine, combinations"
  },
  "N07XX04": {
    "inns": [
      "gamma-hydroxybutyric acid"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "sodium oxybate"
  },
  "R02AD03": {
    "inns": [
      "cocaine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "cocaine"
  },
  "R05DA01": {
    "inns": [
      "ethylmorphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Ethylmorphine"
  },
  "R05DA03": {
    "inns": [
      "hydrocodone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Hydrocodone"
  },
  "R05DA04": {
    "inns": [
      "codeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Codeine"
  },
  "R05DA05": {
    "inns": [
      "morphine",
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Opium alkaloids with morphine"
  },
  "R05DA06": {
    "inns": [
      "normethadone"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Normethadone"
  },
  "R05DA08": {
    "inns": [
      "pholcodine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Pholcodine"
  },
  "R05DA10": {
    "inns": [
      "thebacon"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Thebacon"
  },
  "R05DA12": {
    "inns": [
      "acetyldihydrocodeine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Acetyldihydrocodeine"
  },
  "R05DB15": {
    "inns": [
      "zipeprol"
    ],
    "list": [
      "psychotropic"
    ],
    "schedule": [
      "II"
    ],
    "name": "Zipeprol"
  },
  "R05FA": {
    "inns": [
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Opium derivatives and expectorants"
  },
  "R05FA01": {
    "inns": [
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "Opium derivatives and mucolytics"
  },
  "R05FA02": {
    "inns": [
      "opium"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "opium derivatives and expectorants"
  },
  "S01HA01": {
    "inns": [
      "cocaine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "cocaine"
  },
  "S01XA06": {
    "inns": [
      "ethylmorphine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "II"
    ],
    "name": "ethylmorphine"
  },
  "S02DA02": {
    "inns": [
      "cocaine"
    ],
    "list": [
      "narcotic"
    ],
    "schedule": [
      "I"
    ],
    "name": "cocaine"
  }
};

export const CONTROLLED_META = {
  "sources": [
    "INCB Yellow List, narcotic drugs under the 1961 Single Convention (64th ed., 2025)",
    "INCB Green List, psychotropic substances under the 1971 Convention (2025, V.24-12193)"
  ],
  "status": "DRAFT — requires clinical sign-off before the feature is enabled",
  "note": "Flags that a medicine is internationally controlled. It is NOT a ruling on legality at any destination. Destination rules are national and vary.",
  "count": 153
};

// Parse the ATC code out of a medicine's `description` ("A07DA01 - Diphenoxylate").
export const parseAtc = (description = "") => {
  const m = /^\s*([A-Z]\d{2}[A-Z]{0,2}\d{0,2})\b/.exec(String(description).trim());
  return m ? m[1] : null;
};

// Given the member's `medicines` (each { description, ... }), return the subset
// that is internationally controlled, annotated with list + schedule.
// This FLAGS controlled medicines for traveller awareness. It does NOT decide
// legality at any destination.
export const findControlledMedicines = (medicines = []) => {
  const out = [];
  (medicines || []).forEach((med) => {
    const atc = parseAtc(med?.description);
    if (!atc) return;
    const hit = CONTROLLED_ATC[atc];
    if (hit) {
      out.push({
        atc,
        description: med.description,
        name: hit.name,
        inns: hit.inns,
        list: hit.list,          // ['narcotic'] | ['psychotropic'] | both
        schedule: hit.schedule,  // e.g. ['I'] or ['IV']
      });
    }
  });
  return out;
};
